import script from "./GoldenPourGame.vue?vue&type=script&setup=true&lang=js"
export * from "./GoldenPourGame.vue?vue&type=script&setup=true&lang=js"

import "./GoldenPourGame.vue?vue&type=style&index=0&id=3ce446be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce446be"]])

export default __exports__